module.exports = __webpack_public_path__ + "img/noaccess.8c6f3b66.png";